<template>
  <li
    v-bind:class="{
      selected: selected_tag == tag_info.value,
      hide: tag_info.value == '' && !tag_info.children.length,
    }"
    class="tag"
    :tag="tag_info.value"
    :key="tag_info.id"
    :tag_id="tag_info.id"
  >
    <div
      @click="clickTag"
      v-bind:class="{
        checked: selected_tag == tag_info.value,
      }"
      class="tag-wrap"
      @mouseover="showTooltip(tag_info.value)"
      v-baidu-event-tracking="{ feature: '标签操作', action: pinned ? '置顶标签点击' : '全部标签点击' }"
    >
      <span>
        <i
          v-if="tag_info.children.length && is_mobile & !$isElectron"
          v-bind:class="{
            'arrow-down': showChildren,
            'arrow-right': !showChildren,
            expand: true,
          }"
          @touchstart.stop.prevent="expandChildren"
          v-baidu-event-tracking="{ feature: '标签操作', action: '展开收起' }"
        >
          <svg-icon :iconClass="'tagExpand'"></svg-icon>
        </i>
        <i
          v-if="(tag_info.children.length && !is_mobile) || (tag_info.children.length && $isElectron)"
          v-bind:class="{
            'arrow-down': showChildren,
            'arrow-right': !showChildren,
            expand: true,
          }"
          @click.stop.prevent="expandChildren"
        >
          <svg-icon :iconClass="'tagExpand'"></svg-icon>
        </i>
        <i @click.stop.prevent="click_tag_icon" v-if="tag_info.icon && tag_info.icon != -1" class="tag_emoji">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('components.TagTree.change_tag_icon')"
            placement="bottom"
            :visible-arrow="false"
            :transition="''"
            @mouseenter.native="tooltip.tag_icon_emoji = true"
            @mouseleave.native="tooltip.tag_icon_emoji = false"
            v-model="tooltip.tag_icon_emoji"
            :disabled="is_mobile"
          >
            <p>{{ tag_info.icon }}</p>
          </el-tooltip>
        </i>

        <i
          v-else
          @click.stop.prevent="click_tag_icon"
          :title="$t('components.TagTree.change_tag_icon')"
          class="tag-icon-edit"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('tooltips.tag_icon')"
            placement="bottom"
            :visible-arrow="false"
            :transition="''"
            @mouseenter.native="tooltip.tag_icon = true"
            @mouseleave.native="tooltip.tag_icon = false"
            v-model="tooltip.tag_icon"
            :disabled="is_mobile"
          >
            <svg-icon :iconClass="'changeTagIcon'"></svg-icon>
          </el-tooltip>
        </i>

        <el-tooltip :content="tag_info.display" :open-delay="1000">
          <label v-html="tag_info.display"></label>
        </el-tooltip>
      </span>
      <div class="right" @click.stop>
        <el-dropdown v-if="show[tag_info.value] && !is_mobile" size="medium" trigger="click" @command="handleCommand">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('tooltips.edit_tag')"
            placement="bottom"
            :visible-arrow="false"
            :transition="''"
            @mouseenter.native="tooltip.edit_tag = true"
            @mouseleave.native="tooltip.edit_tag = false"
            v-model="tooltip.edit_tag"
          >
            <i class="el-icon-more" v-if="!is_mobile" @click="getTagPosition"></i>
          </el-tooltip>
          <el-dropdown-menu slot="dropdown" class="dropdownMenu">
            <div class="popover-menu">
              <el-dropdown-item
                v-if="!isPinned"
                command="pinTag"
                v-baidu-event-tracking="{ feature: '标签操作', action: '置顶' }"
                >{{ $t('components.TagTree.pin') }}</el-dropdown-item
              >
              <el-dropdown-item
                v-if="isPinned"
                command="unpinTag"
                v-baidu-event-tracking="{ feature: '标签操作', action: '取消置顶' }"
                >{{ $t('components.TagTree.unpin') }}</el-dropdown-item
              >
              <el-dropdown-item
                command="renameTag"
                v-baidu-event-tracking="{ feature: '标签操作', action: '重命名' }"
                >{{ $t('components.TagTree.rename') }}</el-dropdown-item
              >
              <el-dropdown-item
                command="changeTagIcon"
                v-baidu-event-tracking="{ feature: '标签操作', action: '更换图标' }"
                >{{ $t('components.TagTree.change_tag_icon') }}</el-dropdown-item
              >
              <el-divider class="divider"></el-divider>
              <el-dropdown-item
                command="deleteTag"
                class="deleteTag"
                v-baidu-event-tracking="{ feature: '标签操作', action: '删除标签' }"
                >{{ $t('components.TagTree.delete_tag') }}</el-dropdown-item
              >
            </div>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown v-if="is_mobile" size="medium" trigger="click" @command="handleCommand">
          <i class="el-icon-more" v-if="is_mobile" @click="getTagPosition"></i>
          <el-dropdown-menu slot="dropdown" class="dropdownMenu">
            <el-dropdown-item v-if="!isPinned" command="pinTag">{{ $t('components.TagTree.pin') }}</el-dropdown-item>
            <el-dropdown-item v-if="isPinned" command="unpinTag">{{ $t('components.TagTree.unpin') }}</el-dropdown-item>
            <el-dropdown-item command="renameTag">{{ $t('components.TagTree.rename') }}</el-dropdown-item>
            <el-dropdown-item command="changeTagIcon">{{ $t('components.TagTree.change_tag_icon') }}</el-dropdown-item>
            <el-divider class="divider"></el-divider>
            <el-dropdown-item command="deleteTag" class="deleteTag">{{
              $t('components.TagTree.delete_tag')
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <lay-transition>
      <ul v-if="showChildren" class="tag_ul children_ul">
        <tag-tree
          v-for="child_tag_info in tag_info.children"
          v-bind:key="child_tag_info.value"
          :level="level + 1"
          :tag_info="child_tag_info"
          :selected_tag="selected_tag"
          v-on:tag-clicked="clickChildTag"
          v-on:rename-tag-clicked="renameChildTag"
          v-on:change-tag-icon-clicked="changeTagIconClick"
        >
        </tag-tree>
      </ul>
    </lay-transition>
  </li>
</template>
<script>
import DBUtil from '../utils/DBUtil'
import LayTransition from './LayTransition'

export default {
  name: 'TagTree',
  props: {
    pinned: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 0,
    },
    tag_info: {
      type: Object,
      default: {},
    },
    selected_tag: {
      type: String,
      default: null,
    },
  },
  components: {
    LayTransition,
  },
  computed: {
    showChildren() {
      if (this.hideChildren) return false
      if (this.pinned) {
        return this.$store.state.expandedPinnedTagValues.includes(this.tag_info.value)
      } else {
        return this.$store.state.expandedTagValues.includes(this.tag_info.value)
      }
    },
    isPinned() {
      for (const key in this.$store.state.pinned_tags) {
        const pinned_tag = this.$store.state.pinned_tags[key]
        if (pinned_tag.name == this.tag_info.value) return true
      }
      return false
    },
    is_mobile() {
      return this.$store.state.is_mobile
    },

    getUlHeight() {
      let count = this.getChildrenCount(this.tag_info)
      if (count) {
        return count * 40 + 'px'
      } else {
        return '0'
      }
    },
  },
  methods: {
    showTooltip(id) {
      this.$set(this.show, id, true) // 更新show对象的值为true，显示el-tooltip组件
    },
    // 获取tag_info children 下的所有子节点的个数
    getChildrenCount(tag_info) {
      let count = 0
      if (tag_info.children) {
        count += tag_info.children.length
        for (const key in tag_info.children) {
          const child_tag_info = tag_info.children[key]
          count += this.getChildrenCount(child_tag_info)
        }
      }
      return count
    },

    clickTag() {
      this.$emit('tag-clicked', this.tag_info.value, this.pinned)
    },
    clickChildTag(value, pinned) {
      // 置顶的tag children 点击时也需要拼接&pin
      this.$emit('tag-clicked', value, this.pinned ? true : pinned)
    },
    expandChildren() {
      if (this.pinned) {
        if (this.showChildren) {
          this.$store.commit('removeExpandedPinnedTagValue', this.tag_info.value)
        } else {
          this.$store.commit('addExpandedPinnedTagValue', this.tag_info.value)
        }
      } else {
        if (this.showChildren) {
          this.$store.commit('removeExpandedTagValue', this.tag_info.value)
        } else {
          this.$store.commit('addExpandedTagValue', this.tag_info.value)
        }
      }
    },
    handleCommand(command, event) {
      if (!this.tag_info.value) {
        this.$message.error(this.$t('components.TagTree.tag_cannot_be_empty'))
        return
      }
      if (command === 'pinTag') {
        this.pinTag()
      } else if (command === 'unpinTag') {
        this.unpinTag()
      } else if (command === 'renameTag') {
        this.renameTag(this.level)
      } else if (command === 'deleteTag') {
        this.deleteTag()
      } else {
        this.changeTagIcon(event)
      }
    },
    pinTag() {
      const tags = this.tag_info.value.split('/')
      if (tags.indexOf('') > -1) {
        this.$message.error(this.$t('components.TagTree.pin_tag_cannot_be_empty'))
        return
      }
      if (!this.tag_info.value) {
        this.$message.error(this.$t('components.TagTree.pin_tag_cannot_be_empty'))
        return
      }
      if (this.$store.state.pinned_tags.length >= 10) {
        this.$message.error(this.$t('components.TagTree.max_pinned_tag_count'))
        return
      }

      DBUtil.pinTag(this.tag_info.value).then((tagInfo) => {
        this.$store.commit('addPinnedTag', this.tag_info)
        this.$message.success(this.$t('components.TagTree.pin_tag_success'))
      })
      // this.$http
      //     .post('/api/tag/pin', {
      //         'tag': vm.tag_info.value
      //     })
      //     .then(response => {
      //         if (response.data && response.data.code === -1) {
      //             vm.$message.error(response.data.message);
      //         } else if (response.data && response.data.code === 0) {
      //             vm.$store.commit('addPinnedTag', vm.tag_info);
      //         }
      //     });
    },
    unpinTag() {
      DBUtil.unpinTag(this.tag_info.value).then((tagInfo) => {
        this.$store.commit('removePinnedTag', this.tag_info.value)
        this.$message.success(this.$t('components.TagTree.unpin_tag_success'))
      })
      // this.$http
      //     .post('/api/tag/unpin', {
      //         'tag': vm.tag_info.value
      //     })
      //     .then(response => {
      //         if (response.data && response.data.code === -1) {
      //             vm.$message.error('取消置顶失败');
      //         } else if (response.data && response.data.code === 0) {
      //             vm.$store.commit('removePinnedTag', vm.tag_info.value);
      //         }
      //     });
    },
    renameTag(level) {
      this.$emit(
        'rename-tag-clicked',
        {
          clientX: this.tag_position.clientX,
          clientY: this.tag_position.clientY,
        },
        this.tag_info.value,
        true,
        level,
        this.parentNodeWidth,
      )
    },
    renameChildTag(position, value, isTree, level, parentNodeWidth) {
      this.$emit(
        'rename-tag-clicked',
        {
          clientX: position.clientX,
          clientY: position.clientY,
        },
        value,
        true,
        level,
        parentNodeWidth,
      )
    },
    changeTagIcon() {
      if (!this.tag_info.value) {
        this.$message.error(this.$t('components.TagTree.tag_cannot_be_empty'))
        return
      }
      this.$emit('change-tag-icon-clicked', this.tag_position, this.tag_info.value)
    },
    /* getTagPosition */
    getTagPosition(e) {
      const { clientX, clientY } = e
      this.tag_position = { clientX, clientY }
      this.tooltip.edit_tag = false
      this.parentNodeWidth = e.target.parentNode.parentNode.parentNode.parentNode.clientWidth
    },
    /* changeTagIconClick */
    changeTagIconClick(value, tag_name) {
      this.$emit('change-tag-icon-clicked', value, tag_name)
    },
    click_tag_icon(e) {
      this.getTagPosition(e)
      this.changeTagIcon()
      this.tooltip.tag_icon_emoji = false
      let elTipDom = e.target.parentNode.getAttribute('aria-describedby')
      let elTip = document.getElementById(elTipDom)
      if (elTip) {
        elTip.style.display = 'none'
      }
    },
    deleteTag() {
      this.$confirm(
        this.$t('components.TagTree.delete_tag_messages.text', {
          tag: this.tag_info.value,
        }),
        this.$t('components.TagTree.delete_tag_messages.title',),
        {
          confirmButtonText: this.$t('components.TagTree.delete_tag_messages.confirm'),
          cancelButtonText: this.$t('components.TagTree.delete_tag_messages.cancel'),
          confirmButtonClass: 'delete-confirm-button',
        },
      )
        .then(() => {
          const loadingTip = this.$message({
            dangerouslyUseHTMLString: true,
            message: `<div class='tip-content'><div>${this.$t(
              'components.TagTree.delete_tag_messages.deleting',
            )}</svg></div></div>`,
            duration: 0,
            offset: window.innerHeight - 100,
            customClass: 'loading-tip',
          })

          DBUtil.deleteMemosOfTag(this.tag_info.value).then(() => {
            loadingTip.close()
            if (this.deleteTip) {
              this.deleteTip.close()
            }
            this.deleteTip = this.$message({
              dangerouslyUseHTMLString: true,
              message: `<div class='tip-content'><div>${this.$t(
                'components.TagTree.delete_tag_messages.success',
              )}</div><div class='tip-action'><span  class='undoText'>${this.$t(
                'components.TagTree.delete_tag_messages.undo',
              )}</span> <svg  class='closeTipIcon' width='13' height='13' viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M2.74577 1.9209L1.9209 2.74577L6.17513 7L1.9209 11.2542L2.74577 12.0791L7 7.82487L11.2542 12.0791L12.0791 11.2542L7.82487 7L12.0791 2.74577L11.2542 1.9209L7 6.17513L2.74577 1.9209Z' fill='#8F9193'/</svg></div></div>`,
              duration: 3000,
              offset: window.innerHeight - 100,
              customClass: 'delete-tip',
              onClose: () => {
                if (!this.isClickUndo) {
                  DBUtil.clearDeleteMemoSlugs()
                  DBUtil.clearDeleteTag()
                }
              },
            })
            this.deleteTip.$el.querySelector('span').onclick = async () => {
              this.isClickUndo = true
              this.deleteTip.close()
              const msgTip = this.$message({
                dangerouslyUseHTMLString: true,
                message: `<div class='tip-content'><div>${this.$t(
                  'components.TagTree.delete_tag_messages.undoing',
                )}</svg></div></div>`,
                duration: 0,
                offset: window.innerHeight - 100,
                customClass: 'undo-tip',
              })
              const res = await DBUtil.undoDeleteMemo()
              msgTip.close()
            }
            this.deleteTip.$el.querySelector('svg').onclick = () => {
              DBUtil.clearDeleteMemoSlugs()
              DBUtil.clearDeleteTag()
              this.deleteTip.close()
              this.isClickUndo = false
            }
          })
        })
        .catch(() => {})
    },
  },
  data() {
    return {
      tag_position: {
        clientX: 0,
        clientY: 0,
      },
      tooltip: {},
      deleteTip: null,
      isClickUndo: false,
      hideChildren: false,
      parentNodeWidth: 0,
      show: {},
    }
  },
}
</script>
<style scoped>
.tag_ul {
  font-size: 14px;
  list-style-type: none;
  padding-inline-start: 0;
  border-left: 2px solid var(--BgTestAnnouncement);
  margin-left: 26px;
  padding-left: 12px;
  /* max-height: 0; */
  /* overflow: hidden; */
  /* transition: all 0.3s ease-in-out; */
}

ul li.tag {
  /* line-height: 36px; */
  padding-left: 0;
  cursor: pointer;
}
ul li.tag .tag-wrap {
  /* padding-left: 20px; */
  position: relative;
  /* height: 36px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 13px;
}
ul li.tag div span {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

ul li.tag div span label {
  margin-left: 3px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  line-height: 24px;
}
ul li.tag div span i {
  font-style: normal;
  user-select: none;
  transition: background 20ms ease-in 0.3s;
  cursor: pointer;
  border-radius: 3px;
  font-size: 16px;
  text-align: center;
  display: inline-block;
  font-family: Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  position: relative;
  top: 0px;
}

ul li.tag div span i.tag_emoji {
  font-size: 14px;
}

ul li.tag div span i.tag_emoji,
ul li.tag div span i.tag-icon-edit {
  /* margin-left: 7px; */
  /* padding: 0 4px; */
  /* display: flex; */
  margin-left: 2px;
  flex-shrink: 0;
}

ul li.tag div span i.tag_emoji p,
ul li.tag div span i.tag-icon-edit {
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  position: relative;
}

ul li.tag div span i.tag-icon-edit svg {
  /* position: absolute;
  top: 3px;
  left: 3px; */
  margin-top: 3px;
}
ul li.tag div span i.tag-icon-edit {
  /* padding: 4px 5px; */
}
ul li.tag div span i:active,
ul li.tag div span i:focus,
ul li.tag div span i:hover {
  background: var(--hoverBg);
  border-radius: 3px;
  color: #9d9d9d;
}
ul li .checked .svg-icon {
  fill: #fff;
  color: #fff;
}
ul li.tag.selected > div {
  background: var(--green);
  color: #fff;
  border-radius: 5px;
  font-weight: bold;
}

.expand {
  padding: 5px;
}
.expand .svg-icon {
  width: 12px;
  height: 12px;
}

ul li.tag.selected > div .expand svg path {
  fill: #fff;
}

ul li.tag > div:hover {
  background: var(--hoverBg);
  border-radius: 5px;
}

ul li.selected > div:hover {
  background: var(--green);
}

ul li.selected > div:hover div.right i {
  color: #fff;
}

ul li.tag div.right i,
ul.tags li.selected ul li div.right i svg {
  color: grey;
}

ul li.tag div.right .el-dropdown {
  opacity: 0;
}

.mobile ul li.tag div.right .el-dropdown {
  opacity: 1;
}
.mobile ul li.tag div.right .el-dropdown {
  display: inline-block;
  width: 30px;
  text-align: center;
}
ul li.tag div:hover div.right .el-dropdown {
  opacity: 1;
  text-align: center;
  /* background: rgba(255, 255, 255, 0.8); */
}
/* body.dark_mode ul li.tag div:hover div.right i {
  color: #fff;
} */

/* .children-enter-active，.children-leave-active {
  transition: all 0.1s ease;
}

.children-enter,
.children-leave-to {
  transform: translateY(-30px);
  opacity: 0;
} */

ul.tags li.selected div.right i svg {
  fill: #ffffff !important;
  color: #ffffff;
}

.children_ul li:hover div.right i svg {
  fill: #9d9d9d;
  color: #9d9d9d;
}

ul.expanded {
  margin-top: 5px;
  margin-bottom: 5px;
}
ul li.tag.selected > div:hover div.right i svg {
  fill: #9d9d9d;
  color: #9d9d9d;
}
.arrow-down svg {
  transform: rotate(90deg);
  animation: arrowDown 0.3s ease-in-out;
}

@keyframes arrowDown {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(90deg);
  }
}
.arrow-right svg {
  transform: rotate(0deg);
}
/deep/ .el-dropdown-menu__item:hover {
  color: #55bb8e !important;
  background-color: unset !important;
}

.dropdownMenu {
  padding: 0;
  width: 140px;
}
.dropdownMenu li {
  padding: 5px 15px !important;
  line-height: 20px;
  color: #454545;
}
.dropdownMenu li:first-child {
  padding-top: 15px !important;
}

.dropdownMenu li.deleteTag {
  color: #ad2121;
  padding-bottom: 15px !important;
}

.dropdownMenu li.deleteTag:hover {
  color: #ad2121 !important;
}

.dropdownMenu .divider {
  margin: 10px 0;
}
body.dark_mode .dropdownMenu li {
  color: #6d6d6d;
}
body.dark_mode .dropdownMenu li.deleteTag {
  color: #ad2121;
}

.expand {
  position: absolute !important;
  left: 0 !important;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  top: 50% !important;
  transform: translate(0, -50%);
  cursor: pointer;
}

.expand:hover {
  background: none !important;
}

ul li.tag div:hover .expand {
  opacity: 1;
}

.mobile .expand {
  opacity: 1;
}
.el-icon-more {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
}
.el-icon-more:hover {
  background: var(--hoverBg);
}
</style>
<style>
.delete-tip,
.undo-tip,
.loading-tip {
  min-width: 100px !important;
  border-radius: 5px !important;
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.8) !important;
  border: none;
}
.delete-tip .tip-content {
  width: 235px;
}
.undo-tip,
.loading-tip {
  width: 150px;
}
.delete-tip .tip-content,
.delete-tip .tip-action {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  align-items: center;
}

.delete-tip .tip-action {
  cursor: pointer;
}

.delete-tip .tip-action span {
  color: #589ef8;
}

.delete-tip .tip-action span:hover {
  color: #55bb8e;
}
.delete-tip .tip-action svg {
  margin-left: 16px;
}

.delete-tip i,
.loading-tip i,
.undo-tip i {
  display: none !important;
}

.delete-tip p,
.loading-tip p,
.undo-tip p {
  color: #fff !important;
}

.dark_mode .delete-tip,
.dark_mode .loading-tip,
.dark_mode .undo-tip {
  border-color: transparent;
}

.delete-confirm-button {
  background-color: #ad2121 !important;
  border-color: #ad2121 !important;
  border-radius: 4px !important;
  color: #fff;
}
</style>
